import { useCallback, useContext, useEffect, useState } from "react";
import {Box,Drawer} from "@mui/material";
import posthog from "../utils/posthog";
import Header from "./Header";
import CameraPermission from "./bodyScan/CameraPermission";
import { SignUpProps } from "../types/interfaces";
import { CLOTHING_BANNER_SCAN, CLOTHING_CUSTOM_FIT_SCAN, CLOTHING_CUSTOM_SCAN, maleMeasurementProgress, measurementProgress } from "../utils/constants";
import { GenderType } from "../utils/enums";
import SpecificButton from "../atoms/specificButton/SpecificButton";
import { LanguageContext } from "../utils/context/languageContext";
import { LanguageKeys } from "../utils/languageKeys";

function SignUp({
	scanId,
	userDetails,
	config,
	isVideoUploadedCorrect,
	isMeasurementAvailable,
	onComplete,
	isSuccess,
	onCustomScanSuccess,
	swan,
}: SignUpProps) {
	const { gender, shopDomain, heightInCm, deviceFocalLength, userName, email, scanType } = userDetails || {};
	const isCustom = [CLOTHING_CUSTOM_SCAN, CLOTHING_BANNER_SCAN, CLOTHING_CUSTOM_FIT_SCAN].includes(scanType ?? "");
	const [showDrawer, setShowDrawer] = useState(true);
	const handlePostHogEvent = () => {
		posthog.capture(shopDomain??"", {
			scanID: scanId,
			email: email,
			height: heightInCm,
			focalLength: deviceFocalLength,
			clothesFit: "0",
			gender: gender,
		});
	};

	const handleSignUp = useCallback(async () => {
		try {
			if (isCustom) {
				await swan?.auth.addUser({
					scanId,
					email,
					name: userName,
					gender,
					height: heightInCm,
				});
				onCustomScanSuccess?.();
			}
			handlePostHogEvent();
		} catch (error) {
			console.log(error);
		}
	}, [isCustom]);

	const { translate } = useContext(LanguageContext) || {};

	useEffect(() => {
		if (isVideoUploadedCorrect || isMeasurementAvailable) {
			handleSignUp();
		}
	}, [isVideoUploadedCorrect, isMeasurementAvailable]);

	const showNextButton = isSuccess ||  isVideoUploadedCorrect || isMeasurementAvailable;

	return (
		<Box className="flex h-full w-full flex-col common-ui-main">
			<div className="h-full w-full flex-col items-center justify-center flex">
				<CameraPermission loader={config?.loader} setShowDrawer={setShowDrawer} />
				<Drawer
					open={showDrawer}
					onClose={(_, reason) => {
						if (reason === "backdropClick") {
							return;
						}
					}}
					className="camera-drawer"
					anchor="bottom"
				>
					<div
						className="max-w-[28rem] mx-auto w-full h-full flex text-center flex-col justify-between items-center bg-primary rounded-t-[30px]  p-[1rem]"
						style={{ background: config?.style?.base?.backgroundColor }}
					>
						<div className="w-full h-full flex flex-col">
							<Header title={translate?.(LanguageKeys.measurementsBeingTaken)} />
							<div className="flex items-center justify-center flex-1">
								<video preload="auto" className="max-h-[calc(100vh-450px)] mx-auto w-full object-contain border-none" muted loop autoPlay playsInline>
									<source src={gender === GenderType.Male ? maleMeasurementProgress : measurementProgress} type="video/mp4" />
								</video>
							</div>
							{showNextButton && <SpecificButton className="!w-[180px] mx-auto" buttonText={translate?.(LanguageKeys.next)} buttonFunc={()=>{onComplete?.()
							}} />}
						</div>
					</div>
				</Drawer>
			</div>
		</Box>
	);
}
export default SignUp;
